import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import startOfISOWeek from "date-fns/startOfISOWeek";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import endOfISOWeek from "date-fns/endOfISOWeek";
import isSameMonth from "date-fns/isSameMonth";
import isSameDay from "date-fns/isSameDay";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";



const Calendar = ({setLongestStreak}) => {

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const[hotStreak,setHotStreak]=useState([]);

  const[activeDays,setactiveDays]=useState([]);

  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  const configData = useSelector((state) => state.configSlice);

  useEffect(() => {

    fetchCalenderData();
    
  }, [currentMonth]);

  const changedMonth=moment(currentMonth)

  const month = changedMonth.month(); 

  const year = changedMonth.year(); 

  const fetchCalenderData = async () => {

    const reponse = await axios.get(
      `${configData?.config?.apiBaseUrl}/api/moodanalyticsCalender/${uuid}/${month}/${year}`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

     setHotStreak(reponse?.data?.data?.hotStreak || []) ;
     setactiveDays(reponse?.data?.data?.activeDays || []);
     setLongestStreak(reponse?.data?.data?.longestStreakLength || []);

  };

  const renderHeader = () => {
    const dateFormat = "MMMM yyyy";

    return (
      <div className="header row flex-middle">
        <div className="col-2 col-start">
          <FaAngleLeft className="icon" onClick={prevMonth} />
        </div>
        <div className="col-8 col-center">
          <span className="monthheading">{format(currentMonth, dateFormat)}</span>
        </div>
        <div className="col-2 col-end" onClick={nextMonth}>
          <FaAngleRight className="icon" />
        </div>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = "eee";
    const days = [];
    let startDate = startOfISOWeek(currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          <strong className="text-dark">{format(addDays(startDate, i), dateFormat)}</strong>
        </div>
      );
    }
    return <div className="days row">{days}</div>;
  };
  const parseISODateStrings = (isoDateStrings) => {
    return isoDateStrings?.map((isoDateString) => new Date(isoDateString));
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfISOWeek(monthStart);
    const endDate = endOfISOWeek(monthEnd);
    const dateFormat = "d";
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = "";


    const hotStreakS = parseISODateStrings(hotStreak[0]);

    const activeStreaks = parseISODateStrings(activeDays);

  
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const isHot = hotStreakS?.some((date) => isSameDay(cloneDay, date));
        const isActive = activeStreaks?.some((date) => isSameDay(cloneDay, date));
        days.push(
          <div
          className={`col cell ${
            !isSameMonth(day, monthStart) ? "disabled" : 
            isHot ? "selected" : 
            isActive ? "activeday" : "" 
          }`}
            key={format(day, "yyyyMMdd") + i}
            // onClick={() => onDateClick(cloneDay)}
            >
            <span className="number">{formattedDate}</span>
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  };

  // const onDateClick = (day) => {
  //   setSelectedDate(day);
  // };

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  return (
    <div className="calendar">
      {renderHeader()}
      {renderDays()}
      {renderCells()}
    </div>
  );
};

export default Calendar;
